import GeneralCRUDModel, {
  ACTION_TYPES as CRUD_ACTION_TYPES,
} from "../general-crud";

export const ACTION_TYPES = { ...CRUD_ACTION_TYPES };

export const UnitStoreModel = {
  ...GeneralCRUDModel("/transactional/units"),
};
